exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flightIsNotRebookable[data-v-8df03114]{opacity:.3}.cruise-itinerary td[data-v-8df03114]{line-height:1.8em;border:1px solid #f5f5f5}.total-price-value-small[data-v-8df03114]{color:#98ce44;font-size:1.4em;text-align:right}.outerbox[data-v-8df03114]{width:100%;background-color:#f5f5f5;padding:5px;height:40px}.mybox[data-v-8df03114]{float:left;background-color:#f5f5f5;padding:5px}input[type=checkbox][data-v-8df03114]{transform:scale(1.2)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8df03114","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/rebooking/pagecontent/BookingnoPaxDetails.vue
// module id = 513
// module chunks = 0